import { authHeaders, invokeApi, postRequest } from "../components/network/apiclient";
import { gameLinkEndpoint } from "./endpoint";

export const getLink = (token, onSuccess, onError) =>
    invokeApi(postRequest(gameLinkEndpoint.getPath(), authHeaders(token)), onSuccess, onError);

export const disableLink = (token, onSuccess, onError) =>
    invokeApi(postRequest(gameLinkEndpoint.disablePath(), authHeaders(token)), onSuccess, onError);

export const generateLink = (token, onSuccess, onError) =>
    invokeApi(postRequest(gameLinkEndpoint.generatePath(), authHeaders(token)), onSuccess, onError);
